/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export default () => {
    // Locale list to map AEM languages to BCP 47
    // from https://git.corp.adobe.com/Coral/coral-spectrum/blob/master/coral-utils/src/scripts/I18nProvider.js#L87
    const locales = {
        en: 'en-US',
        'en-us': 'en-US',
        cs: 'cs-CZ',
        'cs-cz': 'cs-CZ',
        da: 'da-DK',
        'da-dk': 'da-DK',
        de: 'de-DE',
        'de-de': 'de-DE',
        es: 'es-ES',
        'es-es': 'es-ES',
        fi: 'fi-FI',
        'fi-fi': 'fi-FI',
        fr: 'fr-FR',
        'fr-fr': 'fr-FR',
        it: 'it-IT',
        'it-it': 'it-IT',
        ja: 'ja-JP',
        'ja-jp': 'ja-JP',
        ko: 'ko-KR',
        'ko-kr': 'ko-KR',
        nb: 'nb-NO',
        'nb-no': 'nb-NO',
        nl: 'nl-NL',
        pl: 'pl-PL',
        'pl-pl': 'pl-PL',
        'nl-nl': 'nl-NL',
        pt: 'pt-BR',
        'pt-br': 'pt-BR',
        ru: 'ru-RU',
        'ru-ru': 'ru-RU',
        sv: 'sv-SE',
        'sv-se': 'sv-SE',
        tr: 'tr-TR',
        'tr-tr': 'tr-TR',
        'zh-cn': 'zh-CN',
        'zh-hans-cn': 'zh-CN',
        'zh-hans': 'zh-CN',
        'zh-tw': 'zh-TW',
        'zh-hant-tw': 'zh-TW',
        'zh-hant': 'zh-TW'
    };

    // Lookup language from html lang property. This property is set based on the user settings in AEM.
    const docLang = document.documentElement.lang.toLowerCase();

    return locales[docLang] || 'en-US';
};
